/**
 * Lieu de livraison — caractère obligatoire conditionnel.
 *
 * Le champ vit en tête de l'étape « Matériel », à la place demandée par la commune
 * (todo §1), et reste TOUJOURS visible : le masquer tant qu'aucune quantité n'est
 * saisie le faisait apparaître tout en haut de l'étape pendant que l'usager
 * remplissait la liste tout en bas, donc hors de son champ de vision.
 *
 * Seul `required` varie :
 *   - rentable « Open Air / Autre » : du matériel livré par nature -> toujours requis ;
 *   - salle classique : requis dès qu'au moins une quantité de matériel est > 0.
 *
 * Il est posé ICI et non dans le template : le rendre inconditionnel bloquerait une
 * réservation de salle sans aucun matériel, où l'adresse n'a aucun sens.
 */

const SECTION_SELECTOR = '.delivery-location-section';
const FIELD_SELECTOR = 'input[name="custom.deliveryLocation"]';
const MATERIAL_SELECTOR = 'input[type="number"][name^="materials."]';

/**
 * Au moins un matériel avec une quantité strictement positive ?
 */
function hasMaterialSelected() {
    return Array.from(document.querySelectorAll(MATERIAL_SELECTOR)).some((input) => {
        const qty = parseInt(input.value, 10);
        return !isNaN(qty) && qty > 0;
    });
}

function applyState(field, required) {
    if (required) {
        field.setAttribute('required', 'required');
        return;
    }

    // On ne vide pas le champ : il est sous les yeux de l'usager, effacer ce qu'il
    // vient d'y taper parce qu'il a remis une quantité à zéro serait incompréhensible.
    field.removeAttribute('required');
    field.classList.remove('is-invalid');
}

export function initDeliveryLocation() {
    const section = document.querySelector(SECTION_SELECTOR);
    if (!section) return;

    const field = section.querySelector(FIELD_SELECTOR);
    if (!field) return;

    // Open Air : le matériel est livré quoi qu'il arrive, l'adresse est due d'office.
    if (section.dataset.alwaysRequired === '1') {
        applyState(field, true);
        return;
    }

    const refresh = () => applyState(field, hasMaterialSelected());

    document.querySelectorAll(MATERIAL_SELECTOR).forEach((input) => {
        input.addEventListener('input', refresh);
        input.addEventListener('change', refresh);
    });

    // État initial : couvre le retour d'un POST refusé, où les quantités saisies
    // sont déjà repeuplées et où le champ doit redevenir obligatoire de lui-même.
    refresh();
}
